import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { StoreModule } from '@ngrx/store';

import { ConfigService } from './config.service';

@NgModule({
	imports: [
		HttpClientModule,
		StoreModule,
	],
})
export class ConfigServiceModule {
	public static forRoot(): ModuleWithProviders {
		return {
			ngModule: ConfigServiceModule,
			providers: [ ConfigService ],
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/config/config-service.module.ts